<template>
  <layout>
    <div style="padding: 32px">
      <BookingWidget
        v-if="$account"
        is-personal
        :user="user"
      />
    </div>
  </layout>
</template>

<script>
import { mapState } from 'vuex'
import BookingWidget from '../../../console/src/bookings/BookingWidget.vue';

export default {
  name: 'Add',

  components: {
    BookingWidget,
  },

  computed: {
    ...mapState('admin-auth', ['token']),

    user() {
      return {
        ...this.$account,
        token: this.token,
      }
    }
  },

  watch: {
    token() {
      // whenever token changes, update widget token also
      this.mapAccountToWidgetUser()
    },
  },
}
</script>
